<div class="page-header d-flex" [ngClass]="panelClass">
    <div class="mr-auto d-flex text-ellipsis" [ngClass]="getLeftClass()">
        <div class="icon-container pr-1" [ngClass]="{'has-subheader': subHeader}" *ngIf="icon">
            <span class="font-size-1-1 text-link" aria-hidden="true" [ngClass]="getIconContainerClasses()">
            </span>
        </div>
        <div class="text-ellipsis">
            <h1 data-test="page-h1" *ngIf="headerType === '1' && !trustAsHtml" class="font-weight-300 text-ellipsis">
                {{header}}
            </h1>
            <h2 data-test="page-h2" *ngIf="headerType === '2' && !trustAsHtml" class="font-weight-300 text-ellipsis">
                {{header}}
            </h2>
            <h1 data-test="page-h1" *ngIf="headerType === '1' && trustAsHtml" class="font-weight-300 text-ellipsis" [innerHTML]="header">
            </h1>
            <h2 data-test="page-h2" *ngIf="headerType === '2' && trustAsHtml" class="font-weight-300 text-ellipsis" [innerHTML]="header">
            </h2>
            <p data-test="page-subheader" class="header-sub text-secondary-4"
               *ngIf="!trustAsHtml">
                {{subHeader}}
            </p>
            <p data-test="page-subheader" class="header-sub text-secondary-4"
               *ngIf="trustAsHtml"
               [innerHTML]="subHeader">
            </p>
        </div>
      <div>
           &nbsp;&nbsp;
          <a
            *ngIf="panelClass === 'row' && trustAsHtml && header.substr(0, 5) !== 'Edit:' && header.includes('-')"
            class="btn btn-border-radius btn-default btn-secondary cursor-pointer google-icon"
            target="_blank" [attr.aria-describedby]="'linkOpensInNewTab'"
            [href]="'https://www.google.com/search?q=' + getWord()"
          >
            <span class="fab fa-google" aria-hidden="true" ngbTooltip="{{ 'Lookup in Google' | translate }}" [placement]="'bottom'"></span>
            <span class="sr-only" translate>Google</span>
          </a>
    </div>
   </div>
    <div class="flex-grow-1" [ngClass]="getRightClass()">
        <ng-content select="content"></ng-content>
        <ng-content select="page-header-content"></ng-content>
    </div>
</div>
